import { Type } from 'class-transformer';
import { IsInt, Min, Max, IsDefined, IsNumber } from 'class-validator';
import { BaseDto } from '../base.dto';

export class OrderPickUpForCreateDto extends BaseDto {
  @IsInt()
  @Min(1)
  @Max(2147483647) // MySql INT(11) max value
  @IsDefined()
  driverId: number;

  @IsInt()
  @Min(1)
  @Max(2147483647) // MySql INT(11) max value
  @IsDefined()
  orderId: number;

  @IsNumber()
  @IsDefined()
  latitude: number;

  @IsNumber()
  @IsDefined()
  longitude: number;

  @Type(() => Date)
  pickupDateTime?: Date;

  @Type(() => Date)
  deliveredDateTime?: Date;
}
